import React from 'react';

export const FehlerPage: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-text-primary">Fehler</h1>
      </div>

      <div className="bg-white border border-table-border rounded-lg p-8 text-center">
        <p className="text-text-muted">
          Fehler-Management wird hier implementiert.
        </p>
      </div>
    </div>
  );
};
